export default {
  not_localised: 'Tämä asiakirja ei ole vielä saatavilla alueellasi. Näytetään englanninkielinen versio.',
};
